import * as React from "react";
import { Redirect } from "react-router-dom";

import { ALL_WORKFLOWS_ROUTE } from "components/router/Routes";

export default function WorkflowsView(): JSX.Element {
    return <Redirect to={ALL_WORKFLOWS_ROUTE.path} />;
}
